module.exports = __webpack_public_path__ + "ov_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_6.jpg
// module id = 877
// module chunks = 0